import constants from '@Common/Core/Constant';
import { ComponentType } from '@Common/Enums';
import chartsConverter from '@Common/Core/ChartConverters';
import { componentDescriptorHelper, IComponentDescriptor } from '@View/Helpers/ComponentDescriptorHelper';
import { Command } from '@Common/ApplicationCore/Command';

const componentGroups = constants.componentGroups;
export const componentMenuGroups = [
    getChartGroupPaletteButton(componentGroups.chartComponents),
    getChartGroupPaletteButton(componentGroups.gridComponents),
    getChartGroupPaletteButton(componentGroups.processComponents),
    null,
    getChartPaletteButton(ComponentType.label),
    getChartPaletteButton(ComponentType.image),
    getChartPaletteButton(ComponentType.uiLine),
    null,
    getChartPaletteButton(ComponentType.menu),
    getChartPaletteButton(ComponentType.button),
    getChartGroupPaletteButton(componentGroups.driverComponents),
    getChartPaletteButton(ComponentType.viewHolder),
    null,
    getChartGroupPaletteButton(componentGroups.otherComponents)
];

function convertType(item): any {
    if (chartsConverter[item.componentType]) {
        item.converter = item.componentType;
        item.componentType = ComponentType.extendedChart;
    }
    return item;
}

type ComponentDescriptor = IComponentDescriptor & { name: string }; // why name?
function getChartPaletteButton(componentType: ComponentType): Command {
    const descriptor = componentDescriptorHelper.getComponentDescriptor(componentType) as ComponentDescriptor;
    return convertType({
        icon: descriptor.toolBarIcon,
        id: componentType,
        name: descriptor.name,
        componentType: componentType,
        canDrag: true
    });
}

function getChartGroupPaletteButton(group: string): Command {
    const descriptors = componentDescriptorHelper.getToolbarComponentDescriptors(group) as ComponentDescriptor[];
    const childButtons = _.map(descriptors, (item: any) => {
        return convertType({
            icon: item.toolBarIcon,
            id: item.componentType,
            name: item.name,
            componentType: item.componentType,
            canDrag: true,
            useText: true
        });
    });
    return convertType({
        icon: descriptors[0].toolBarIcon,
        id: group,
        name: descriptors[0].name,
        children: childButtons,
        componentType: descriptors[0].componentType,
        canDrag: true,
        popup: { className: 'toolbar-popup-tile' }
    });
}
